import { render, staticRenderFns } from "./FileListTable.vue?vue&type=template&id=5bb267c0"
import script from "./FileListTable.vue?vue&type=script&lang=js"
export * from "./FileListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports